export default __webpack_public_path__ + "static/media/spark.559108da.jpeg";